import React, {Component} from 'react';
import {Row, Col, FormControl, Button, InputGroup, Form, Modal, Dropdown } from 'react-bootstrap'
import ReactPaginate from 'react-paginate';
import {format} from 'timeago.js';
import {
  getMessages
} from "./../apis/tutors";
import "../scss/component/pages/InboxDetails.scss";

class InboxDetails extends Component {
  constructor() {
    super();

    this.state = {
      AllMessages: [],
      page: 1,
      paginationpages: 1,
      modalShow:false,
      accept :false,
      reject : false,
      value: "no",
      step:1,
      data: [
        {
          userOne: "James Smith",
          status: "Declined",
          lastmessage: "See you soon",
          userOneProfileImg: ""
        },
        {
          userOne: "Sam J.",
          status: "Accepted",
          lastmessage: "Thanks!",
          userOneProfileImg: ""
        },
        {
          userOne: "Fred K",
          status: "Expired",
          lastmessage: "Where can we meet?",
          userOneProfileImg: ""
        }
      ]
    };
  }
  // getMessages
  getAllMessages = data => {
    let {paginateMessage, paginationpages} = this.state;
    getMessages({token: data.token, id: data.id})
      .then(res => {
          paginationpages = Math.ceil(res.data.length / 5);
          paginateMessage = res.data.filter((message, i) => (i + 1) < 6)
          this.setState({
            AllMessages: res.data,
            paginateMessage,
            paginationpages
          })
        }
      )
      .catch(err =>
        this.setState({
          error: err
        })
      );
  };
  componentDidMount = () => {
    // get Token
    let token = JSON.parse(localStorage.getItem("userDetail"));
    token = `Bearer ${token?.token}`;

    // getMessages
    this.getAllMessages({id: "1234", token});
  };

  setRequest(event) {
    this.setState({
      value: event.target.value
    })
  }
  handlePageClick = data => {
    let {AllMessages, paginateMessage} = this.state;
    let selected = data.selected + 1;
    let start = (selected * 5) - 4;
    let end = selected * 5;
    paginateMessage = AllMessages.filter((value, i) => (start <= i && end >= i))
    this.setState({page: selected, paginateMessage})
  };
  nameFirstChar = (name) => {
    return name = name.charAt(0);
  }

  handelModal = (type) => {
    this.setState({
      modalShow: !this.state.modalShow,
      accept :false,
      reject : false,
      value: "",
      step:1,
      [type] : true
    })
  }

  modalSteps = (type) => {
      if(type === 'next') {
        if(this.state.value === "no"){
          this.setState({step: 3})
        }else if(this.state.value === "yes"){
          this.setState({step: 4})
        }else{
          this.setState({step:this.state.step + 1})
        }
      }else if(type === 'back'){
        this.setState({step:this.state.step - 1})
      } 
  }

  handleChange = (event) => {
   console.log(event.target)
  } 

  render() {
    const {paginationpages, paginateMessage, value, step, modalShow, accept, reject } = this.state;
    return (
      <div className="container">
        <section className="inbox-details">
            <Row className="m-0">
                <Col md={7} className="p-0" >
                    <div className="flex-between-center m-0 booking">
                        <h5>Jonthon</h5>
                        <button className="btn border">Book Lesson</button>
                    </div>
                    <div className="date">10 Mar 2020</div>
                    <div className="notify-msg"><i class="mdi mdi-card-text-outline"></i><p>Lesson confirmed </p><span>05:24</span></div>
                    <div className="notify-msg"><i class="mdi mdi-wechat"></i><p>Lesson confirmed </p><span>05:24</span></div>
                    <div className="user-msg">
                        <div className="circle" >J</div>
                        <div className="msg-body">
                            <h4 className="title">Jonthon</h4>
                            <span>05:24</span>
                            <p className="para">
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                                when an unknown printer took a galley of type and scrambled it to 
                                make a type specimen book.
                            </p>
                        </div>
                    </div>
                    <div className="notify-msg"><i class="mdi mdi-wechat"></i><p>Lesson confirmed </p><span>05:24</span></div>
                    <div className="user-msg">
                        <div className="circle" >J</div>
                        <div className="msg-body">
                            <h4 className="title">Jonthon</h4>
                            <span>05:24</span>
                            <p className="para">
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                                when an unknown printer took a galley of type and scrambled it to 
                                make a type specimen book.
                            </p>
                        </div>
                    </div>
                    <div className="date">10 Mar 2020</div>
                    <div className="user-msg">
                        <div className="circle" >J</div>
                        <div className="msg-body">
                            <h4 className="title">Jonthon</h4>
                            <span>05:24</span>
                            <p className="para">
                                Lorem Ipsum is simply dummy text
                            </p>
                        </div>
                    </div>
                    <div className="date">10 Mar 2020</div>
                    <div className="notify-msg"><i class="mdi mdi-wechat"></i><p>Lesson confirmed </p><span>05:24</span></div> 
                    <div className="typing-box">
                      <div className="btn"><i class="mdi mdi-plus-circle-outline"></i></div>
                      <input className="inputs" placeholder="Type message" type="text" name="message" />
                    </div>
                </Col>
                <Col md={5} className="about-lesson">
                        <h3 className="title">Lesson Details</h3>
                        <div className="card">
                              <div className="circle" >M</div>
                              <h4 className="card-title">Lesson request</h4>
                              <h5 className="name">Mawuli</h5>
                              <p className="para">Expire in</p>
                              <p className="para">Per Lesson</p>
                        </div>
                        <div className="lesson-utils">
                            <div className="abut-util">
                                <p>Start Time</p>
                                <span>Mon 14 May(weekly)</span>
                            </div>
                            <div className="abut-util">
                                <p>Start Time</p>
                                <span>Mon 14 May(weekly)</span>
                            </div>
                            <div className="abut-util">
                                <p>Start Time</p>
                                <span>Mon 14 May(weekly)</span>
                            </div>
                            <div className="abut-util">
                                <p>Start Time</p>
                                <span>Mon 14 May(weekly)</span>
                            </div>
                        </div>
                        <div className="lesson-faq">
                            <h3>Lesson Requirements:</h3>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                                when an unknown printer took a galley of type and scrambled it to 
                                make a type specimen book.
                            </p>
                            <button className="btn w-100 mb-3 filed" onClick={() => this.handelModal('accept')}>Accept</button>
                            <button className="btn w-100" onClick={() => this.handelModal('reject')}>Decline</button>
                        </div>
                        <div className="lesson-faq">
                            <h3>Do you have any quires or questions about this lesson request?</h3>
                            <a href="#">Send Message</a>
                        </div>
                        <div className="lesson-faq">
                            <h3>Lesson Summary</h3>
                            <div className="faq-row">
                              <p>Lesson</p>
                              <span>Maths (GCSE)</span>
                            </div>
                            <div className="faq-row">
                              <p>Star date</p>
                              <span>Maths (GCSE)</span>
                            </div>
                            <div className="faq-row">
                              <p>Time</p>
                              <span>Maths (GCSE)</span>
                            </div>
                            <div className="faq-row">
                              <p>Frequency</p>
                              <span>Maths (GCSE)</span>
                            </div>
                            <div className="faq-row">
                              <p>Location</p>
                              <span>Maths (GCSE)</span>
                            </div>
                            <div className="faq-row">
                              <p>Confirmation Number</p>
                              <span>Maths (GCSE)</span>
                            </div>
                        </div>
                        <div className="lesson-faq">
                            <h3>Potential earnings</h3>
                            <div className="faq-row">
                              <p>Estimated fee per Lesson</p>
                              <span>Maths (GCSE)</span>
                            </div>
                            <div className="faq-row">
                              <p>Service fee</p>
                              <span>Maths (GCSE)</span>
                            </div>
                            <div className="faq-row">
                              <p>Total earning for each lesson</p>
                              <span>Maths (GCSE)</span>
                            </div>
                        </div>
                        <div className="lesson-faq">
                            <a href="#">Help</a>
                        </div>
                        <div className="lesson-faq">
                            <a href="#">Report user</a>
                        </div>
                        <div className="lesson-faq">
                            <h3>Frequently ssked questions</h3>
                            <p className="question">What happen after booking requests?</p>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                                when an unknown printer took a galley of type and scrambled it to 
                                make a type specimen book.
                            </p>
                            <a href="#">Learn more</a>
                        </div>
                        <div className="lesson-faq">
                            <p className="question">What happen after booking requests?</p>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                                when an unknown printer took a galley of type and scrambled it to 
                                make a type specimen book.
                            </p>
                            <a href="#">Learn more</a>
                        </div>
                        <div className="lesson-faq">
                            <p className="question">What happen after booking requests?</p>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                                when an unknown printer took a galley of type and scrambled it to 
                                make a type specimen book.
                            </p>
                            <a href="#">Learn more</a>
                        </div>
                        <div className="lesson-faq">
                            <a href="#">See more articles</a>
                        </div>
                </Col>
            </Row>
            <Modal
                show={modalShow}
                onHide={this.handelModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header closeButton>
                </Modal.Header>
                { accept && (
                  <>
                  <Modal.Body>
                    <h5>Accept Mawuli for weekly lessons?</h5>
                    <p>
                      Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
                      dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
                      consectetur ac, vestibulum at eros.
                    </p>
                  </Modal.Body>
                  <Modal.Footer>
                  <Button onClick={this.handelModal} variant="outline-primary">Accept</Button>
                  <Button onClick={this.handelModal}>Close</Button>
                </Modal.Footer>
                  </>
                )}
                { reject && (
                  <>
                    {step === 1 && (
                      <>
                        <Modal.Body>
                          <h5>Tell us why you can't deliver the lessons?</h5>
                          <p>They would like to book weekly maths Lorem They would like to book weekly maths Lorem They would like to book weekly maths LoremThey would like to book weekly maths LoremThey would like to book weekly maths Lorem</p>
                          <Form.Check
                            className="reason"
                            type="radio"
                            label="I am unavailabel on the day or time (10am Monday 14 May)"
                            name="formHorizontalRadios"
                            id="formHorizontalRadios1"
                            onChange={this.handleChange}
                          />
                          <Form.Check
                            className="reason"
                            type="radio"
                            label="I am unavailabel on the day or time (10am Monday 14 May)"
                            name="formHorizontalRadios"
                            id="formHorizontalRadios2"
                            onChange={this.handleChange}
                          />
                          <Form.Check
                            className="reason"
                            type="radio"
                            label="I am unavailabel on the day or time (10am Monday 14 May)"
                            name="formHorizontalRadios"
                            id="formHorizontalRadios3"
                          />
                          <Form.Check
                            className="reason"
                            type="radio"
                            label="I am unavailabel on the day or time (10am Monday 14 May)"
                            name="formHorizontalRadios"
                            id="formHorizontalRadios4"
                          />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.modalSteps('next')}>Next</Button>
                        </Modal.Footer>
                      </> 
                    )}
                    {step === 2 && (
                      <>
                      <Modal.Body>
                        <h5>Would you like to send Mawuli a special offer to book?</h5>
                        <p>They would like to book weekly They would like to book weeklyThey would like to book weeklyThey would like to book weeklyThey would like to book weekly</p>
                        <Form.Check
                            className="reason"
                            value="yes"
                            checked={value === "yes"}
                            type="radio"
                            onChange={this.setRequest.bind(this)}
                            label="Yes i would like to book a new request"
                            name="formHorizontalRadios1"
                            id="formHorizontalRadios5"
                          />
                          <Form.Check
                            className="reason"
                            value="no"
                            checked={value === "no"}
                            type="radio"
                            onChange={this.setRequest.bind(this)}
                            label="No i dont wish to book a new request"
                            name="formHorizontalRadios1"
                            id="formHorizontalRadios6"
                          />
                        {/* <div className="reason">
                            <InputGroup>
                                <InputGroup.Radio onChange={this.setRequest.bind(this)} checked={value == "yes"} value="yes" aria-label="Radio button for following text input" />
                            </InputGroup>
                            <p>Yes i would like to book a new request</p>
                        </div>
                        <div className="reason">
                            <InputGroup>
                                <InputGroup.Radio onChange={this.setRequest.bind(this)} checked={value != "yes"} value="no" aria-label="Radio button for following text input" />
                            </InputGroup>
                            <p>No i dont wish to book a new request</p>
                        </div> */}
                      </Modal.Body>
                      <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => this.modalSteps('back')}>Back</Button>
                          <Button onClick={() => this.modalSteps('next')}>Next</Button>
                      </Modal.Footer>
                    </>  
                    )}
                    {step === 3 && (
                      <>
                      <Modal.Body>
                        <h5>We'll let Mawuli know that you are unavailable</h5>
                        <p>Tell Mawuli why you can't teach the lesson?</p>
                        <Form.Group className="mt-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Control as="textarea" rows="3" />
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                            <Button onClick={this.handelModal}>Decline Request</Button>
                            <Button variant="outline-primary" onClick={() => this.modalSteps('back')}>Back</Button>
                      </Modal.Footer>
                    </>  
                    )}
                    {step === 4 && (
                      <>
                      <Modal.Body>
                        <h5>Accept Mawuli for weekly lessons?</h5>
                        <p>They would like to book weekly</p>
                        <div className="reason">
                            <div className="offer-utils pr-2 w-50">
                                <h6>Star Date</h6> 
                                <Dropdown>
                                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                                    Date
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>  
                            </div>
                            <div className="offer-utils pl-2 w-50">
                                <h6>Star Time</h6> 
                                <div className="d-flex">
                                  <Dropdown className="w-50">
                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                        10:00
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                      <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                      <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                  <Dropdown className="w-50">
                                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                                    AM
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item href="#">PM</Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>  
                                </div>
                            </div>
                        </div>
                          <div className="reason">
                            <div className="offer-utils w-100">
                                <h6>Location</h6> 
                                <div className="d-flex">
                                  <Dropdown className="w-100">
                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                        10:00
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                      <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                      <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown> 
                                </div>
                            </div>
                          </div>
                          <div className="reason">
                            <div className="offer-utils w-100">
                                <h6>Location</h6> 
                                <div className="d-flex">
                                  <Dropdown className="w-100">
                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                        10:00
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                      <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                      <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown> 
                                </div>
                            </div>
                          </div>
                          <div className="reason">
                            <div className="offer-utils w-100">
                                <h6>Location</h6> 
                                <div className="d-flex">
                                  <Dropdown className="w-100">
                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                        10:00
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                      <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                      <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown> 
                                </div>
                            </div>
                          </div>
                        </Modal.Body>
                      <Modal.Footer>
                            <Button onClick={this.handelModal}>Send Special offer</Button>
                      </Modal.Footer>
                    </>  
                    )}
                  </>
                )}

              </Modal>
        </section>
      </div>
    );
  }
}

export default InboxDetails;
